import React from 'react';

import MaterialTable from "material-table";

import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import {renderDateTimeText, renderDateTimeToListItem} from "../../../utils/datetimehelp";
import {convertISODateTimeToBRLocale, convertISODateTimeToTz} from "../../../common/Util";
import Typography from "@material-ui/core/Typography/Typography";
import {Link, Redirect, withRouter} from "react-router-dom";
import Button from "@material-ui/core/Button";




const tableIcons = {
    Add: AddBox,
    Check: Check,
    Clear: Clear,
    Delete: DeleteOutline,
    DetailPanel: ChevronRight,
    Edit: Edit,
    Export: SaveAlt,
    Filter: FilterList,
    FirstPage: FirstPage,
    LastPage: LastPage,
    NextPage: ChevronRight,
    PreviousPage: ChevronLeft,
    ResetSearch: Clear,
    Search: Search,
    SortArrow: ArrowUpward,
    ThirdStateCheck: Remove,
    ViewColumn: ViewColumn
};



class AutoclaveCiclosTabela extends React.Component {
    constructor(props) {
        super(props);
    };


    componentDidMount(){

    }

    componentDidUpdate(oldProps, oldState){

    }



    getColumns() {


        return [
            {
                title: 'id',
                field: 'id',
                editable: 'never',
                hidden: true
            },
            {
                title: 'Autoclave',
                field: 'codigo',
                editable: 'never',
            },
            {
                title: 'Ciclo',
                field: 'ciclo',
                editable: 'never',
            },

            {
                title: '1a captura',
                field: 'DTInicio',
                render: rowData => <Typography note>{convertISODateTimeToTz(rowData.DTInicio)}</Typography>,
                editable: 'never',
            },

            {
                title: 'Últ. captura',
                field: 'DTFinal',
                render: rowData => <Typography note>{convertISODateTimeToTz(rowData.DTFinal)}</Typography>,
                editable: 'never'
            },

            {
                title: '#Capturas',
                field: 'amostras',
                editable: 'never'
            }

        ];
    }





    render() {
        const { ciclos } = this.props;

        const titulo = `Ciclos`;
        // console.log(ciclos);
        return (
            <div>

            {/*    return (<Button*/}
            {/*    component={Link}*/}
            {/*    to={`/autoclave/ciclo/${a}/${c}`}*/}
            {/*    style={{ textAlign:'center', alignContent: 'center'}}*/}
            {/*>Dados do ciclo</Button> );*/}
            {/*    }*/}
                        <MaterialTable
                            icons={tableIcons}
                            title={titulo}
                            columns={this.getColumns()}
                            data={ciclos}
                            onRowClick= {(event, rowData) => {
                                this.props.history.push(`/autoclave/ciclo/${rowData.codigo}/${rowData.ciclo}` )
                            }}

                            options={{
                                filtering: true,
                                pageSize: 15,
                                pageSizeOptions: [10,15,25],
                                addRowPosition: 'first'
                            }}



                        />


            </div>
        )



    }
}



export default withRouter(AutoclaveCiclosTabela)

